import React from "react";
import Modal from "react-modal";
import PropTypes from "prop-types";
import { XCircle } from "phosphor-react";
import "./index.scss";

const CustomModal = ({
  isOpen,
  children,
  onRequestClose,
  onClose,
  className,
  size,
  blurred,
}) => {
  return (
    <Modal
      overlayClassName={`modal-overlay ${blurred ? "-blur" : ""}`}
      className={`custom-modal -${size} ${className}`}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      ariaHideApp={false}
    >
      <div className="modal-body">{children}</div>
      <button type="button" className="modal-close" onClick={onClose}>
        <XCircle size={24} color="#292b33" />
      </button>
    </Modal>
  );
};

CustomModal.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  size: PropTypes.string,
  blurred: PropTypes.bool,
};

CustomModal.defaultProps = {
  className: "",
  size: "small",
  isOpen: false,
  blurred: false,
};

export default CustomModal;
